<template lang="pug">
	DxValidationGroup.creative-detail
		template(v-if="creative && isGenerating")
			Loader(:text="$tCaption('Generating creative')", :fullscreen="true")
		.flex-col(v-else)
			DetailHeader(v-if="creative && !isFileUploadRequest", ref="header", v-bind="selfBindableOptions")
			template(v-if="$auth.hasCreativeApi() || forceTracker")
				CreativeFile(v-if="creative && isCreativeFile", v-show="!isEditingCreative", :creative="creative", @save-creative="() => $updateCreative('save-creative')", @src-load="base64 => finalAudioBase64 = base64")
					template(slot="actions-right")
						AudioTrackerButton(v-if="dataIsLoadedFirst && creative.IsPublished === true", :title="$tCaption('Revise')", :text="$tCaption('Revise')", icon="fas fa-retweet", @click="showNewRevisionPopup")
				AudioTracker(
					:hidden="isEditingCreative || isSonicScribe || isFileUploadRequest",
					v-if="creative && !isCreativeFile",
					ref="tracker",
					:items="visibleTracks",
					:aggregatedTracks="creative && creative.JsonConfig.aggregatedTracks",
					:loading="!!isLoading || !!isTracksLoading || !!isPublishing || !!loadingItems",
					:loadingText="isPublishing ? $tCaption('Publishing') : null",
					:isPublishing="isPublishing",
					:disabled="!!isEditingCreative || disabled",
					:editingTrack="editingTrack",
					:finalAudioName="creative.RootCreativeName || creative.Name",
					:masterTrackConfig="creative.JsonConfig && creative.JsonConfig.masterTrackConfig",
					:panelVisible="dataIsLoadedFirst",
					:allowPlay="!editingAggregatedTrack",
					:readonly="readonly",
					:isPublishMode="isPublishMode",
					:preventKeyHandles="opts && opts.preventKeyHandles || isSonicScribe",
					:subInsertionsGroupingType="creative.GroupingTypeOnPublishing === 1 ? 'name' : 'target'",
					:language="creative.LanguageCode",
					:showLinksAlways="showLinksAlways.value",
					trackDragHandle=".track-drag-handle",
					@pressedKeys="v => pressedKeys = v",
					@loading="v => trackerIsLoading = v",
					@source-loaded="calcDataIsLoaded",
					@delete-track="onDeleteTrack",
					@delete-tracks="onDeleteTracks",
					@delete-aggregated-track="onDeleteAggregatedTrack",
					@tracks-changed="onTracksChanged",
					@track-dblclick="onTrackDblClick",
					@audio-changed="onAudioChanged",
					@new-audio-recorderd="onNewAudioRecorded",
					@total-duration-changed="onTotalDurationChanged",
					@duplicate-track-tool="(track, data) => duplicateTrack(track, true, data)",
					@master-track-config-changed="onMasterTrackConfigChanged",
					@set-solo-sub-tracks="onSetSoloSubTracks",
					@aggregated-track-reorder="onAggregatedTrackReorder",
					@play-state="v => $emit('play-state', v)")
					template(v-slot:info-panel-actions-left="{ track, aggregatedTrack }")
						template(v-for="plugin in infoPanelActionsWAPIPlugins(track)")
							AudioTrackerButton(v-if="plugin", @click="executeTrackAction(plugin.id, track, null, aggregatedTrack)", :title="plugin.name", :icon="plugin.icon", :active="plugin.active")
					template(v-slot:info-panel-actions-right="{ track, aggregatedTrack }")
						DxDropDownButton.no-text(
							:items="aggregatedTrackActionsList.filter(f => !f.hidden || !f.hidden(track, aggregatedTrack)).map(f => ({ ...f, icon: typeof(f.icon) === 'function' ? f.icon(track, aggregatedTrack) : f.icon }))",
							@item-click="v => executeTrackAction(v.itemData.id, track, v.itemData, aggregatedTrack)",
							display-expr="name",
							key-expr="id",
							:drop-down-options="dropDownOptions",
							:useSelectMode="false",
							styling-mode="outlined",
							:focusStateEnabled="false",
							:class="{ 'has-changed-settings': hasAppliedCustomSettings(track, aggregatedTrack) }"
						)
							template(v-slot:header="{ data }")
								.font-tiny.upper.grey {{data.name()}}
					template(v-slot:canvas-area="{ track }")
						template(v-if="linkingInsertion && !track.__isSubTrack")
							.flex-row.align-center(v-if="linkingInsertion.id !== track.id")
								.links-holder
									.overlay
									.left.link.flex-col.align-center.center(:title="$tCaption('Link to start')", @click="makeLink(track, 'start')")
										fas(icon="link", size="2xs")
									.right.link.flex-col.align-center.center(:title="$tCaption('Link to end')",  @click="makeLink(track, 'end')")
										fas(icon="link", size="2xs")
					template(v-slot:canvas-actions-right-static="{ track }")
						template(v-if="linkingInsertion && !track.__isSubTrack")
							AudioTrackerButton(v-if="linkingInsertion.id === track.id", @click="linkingInsertion = null", :text="$tCaption('Cancel', '@actions')", icon="fas fa-times")
					template(v-slot:canvas-actions-right-inactive="{ track }")
						template(v-if="!linkingInsertion && track.__linkedTo.length")
							.has-linked-to
								fas(icon="link")
					template(v-slot:canvas-actions-right="{ track }")
						template(v-if="!linkingInsertion")
							DxContextMenu(:ref="`contextMenu_${track.id}`", :target="`#contextMenuTarget_${track.id}`"
								:items="prepareContextMenuActions(trackActionsList.filter(f => !f.hidden || !f.hidden(track)).map(f => ({ ...f, text: f.name(), disabled: f.disabled || (f.busy && f.busy(track)), icon: typeof(f.icon) === 'function' ? f.icon(track) : f.icon })))",
								@item-click="v => { if (v.itemData.isGroup) return; executeTrackAction(v.itemData.id, track, v.itemData); v && v.event && v.event.stopPropagation() }",
							)
								template(v-slot:header="{ data }")
									.font-tiny.upper.grey {{data.name()}}
							.adt-button.rounded.clickable.flex-row.align-center.center.canvas-actions-button(@click.stop="executeTrackAction('clip-settings', track)",
								:class="{ 'active': hasAppliedClipSettings(track), 'disabled': !track.__isSrcLoaded }")
								fas(icon="sliders", size="xs")
							.adt-button.rounded.clickable.flex-row.align-center.center.canvas-actions-button(@click.stop="e => $refs[`contextMenu_${track.id}`].instance.show(e)", :id="`contextMenuTarget_${track.id}`", icon="arrow-down"
								:class="{ 'has-changed-settings': hasAppliedCustomTrackSettings(track), 'disabled': !track.__isSrcLoaded }"
							)
								fas(icon="caret-down")
					template(v-slot:canvas-track-name="{ track, trackName }")
						.flex-row.justify.space.center.track-name
							.flex-row.space.align-center.full-width(@click="editInsertion(track)")
								fas(:icon="getTrackIcon(track)")
								span(:title="trackName") {{trackName}}
								span(v-if="track.breakType") ({{breakTypes[track.insertion.BreakType].name()}})
							.track-duration {{$Data.secondsToDisplayValue(track.trimmedDuration)}}
					template(v-slot:track-compact-right-actions="{ track, trackName, aggregatedTrack }")
						a(v-if="track.insertion && track.insertion.Targets && track.insertion.Targets.length", @click="v => executeTrackAction('geoTarget', track)", :title="track.insertion.Targets[0] && track.insertion.Targets[0].LinkedTarget && track.insertion.Targets[0].LinkedTarget.Name")
							i.fas.fa-globe.action
						a(v-else-if="track.insertion && track.insertion.EventRule", @click="v => editInsertion(track)", :title="track.insertion.EventRule.Name")
							i.fas.fa-calendar-check.action
						a(v-if="track.__limitPeriod")
							fas.grey(icon="clock", :title="track.__limitPeriod")
					template(v-slot:track-name="{ track, trackName, aggregatedTrack }")
						.flex-row.justify.space.center.full-height
							.track-name.flex-row.space.align-center.full-width(:style="{ '--color': aggregatedTrack.color || '#333' }")
								.flex-1.flex-row.full-height.align-center
									template(v-if="editingAggregatedTrack && editingAggregatedTrack.trackNumber === aggregatedTrack.trackNumber && ((!editingAggregatedTrackSubTrack && (!track || !track.__isSubTrack)) || editingAggregatedTrackSubTrack === track)")
										DxTextBox(v-if="track && track.__isSubTrack", ref="trackNameBox", :value.sync="track.insertion.Name", stylingMode="filled", @focusOut="setEditingAggregatedTrack(null, 20)", @value-changed="setEditingAggregatedTrack(null)", height="18px")
										DxTextBox(v-else, ref="trackNameBox", :value.sync="aggregatedTrack.name", stylingMode="filled", @focusOut="setEditingAggregatedTrack(null, 20)", @value-changed="setEditingAggregatedTrack(null)", height="18px")
									.track-drag-handle.flex-1(v-else)
										.text(v-if="track && track.__isSubTrack", :title="track.insertion.Name", @click="colorPickerOpened = false; setEditingAggregatedTrack(aggregatedTrack, void 0, track)") {{track.insertion.Name || $tCaption('Track')}}
										.text(v-else, :title="aggregatedTrack.name", @click="colorPickerOpened = false; setEditingAggregatedTrack(aggregatedTrack)") {{aggregatedTrack.name || $tCaption('Track')}}
								.color-picker.flex-row.center.align-center(v-if="editingAggregatedTrack && editingAggregatedTrack.trackNumber === aggregatedTrack.trackNumber", @mousedown="openColorSelector(editingAggregatedTrack)")
									.color-picker-icon
										i.fas.fa-palette
								.color-picker-popup(v-if="editingAggregatedTrack")
									DxColorBox(:value.sync="editingAggregatedTrack.color", :ref="`colorBox_${aggregatedTrack.trackNumber}`", width="0px", height="0px", applyValueMode="instantly", @closed="colorPickerOpened = false; setEditingAggregatedTrack(null)")
							.right.flex-row.space
								a(v-if="track.insertion && track.insertion.Targets && track.insertion.Targets.length", @click="v => executeTrackAction('geoTarget', track)", :title="track.insertion.Targets[0].Name")
									i.fas.fa-globe.action
								a(v-else-if="track.insertion && track.insertion.EventRule", @click="v => editInsertion(track)", :title="track.insertion.EventRule.Name")
									i.fas.fa-calendar-check.action
					template(slot="actions-left-start-common")
						AudioTrackerButton(:text="$tCaption('New track')", icon="fas fa-plus", @click="createNewAggregatedTrack")
					template(slot="actions-left-start-track")
						DxDropDownButton(
							:items="insertionKinds.filter(f => !f.hidden || !f.hidden(_self)).map(f => ({ ...f, icon: `fas fa-${f.icon}` }))",
							text="Add",
							@item-click="v => createInsertion(v.itemData.id)",
							display-expr="name",
							key-expr="id",
							:drop-down-options="{ width: 230 }",
							styling-mode="filled",
							:focusStateEnabled="false"
						)
					template(v-slot:canvas-actions-left-static="{ track }")
						.flex-col.nowrap.canvas-indicator.variants.center.align-center(v-if="track.__totalSubInsertions", :title="`+${track.__totalSubInsertions} ${$tCaption('variant(s)')}`")
							span(v-if="!track.insertion.LastProcessingJob || track.insertion.LastProcessingJob.Status !== 3") +{{track.__totalSubInsertions}}
							.flex-row.space-small.align-center.clickable(v-else, @click.stop="showLastProcessingJobInfo(track.insertion.LastProcessingJob, track)")
								fas(icon="triangle-exclamation")
								span {{track.__totalSubInsertions}}
					template(slot="actions-left-start")
						CreativeSimulateRules(:creative="creative", :insertions="loadedTracks && loadedTracks.map(f => f.insertion)", @change="onSimulateRulesPopupChanged", :simulatedItems="simulatedItems")
					template(slot="actions-left")
						AudioTrackerButton(v-if="visibleTracks.length", :title="$tCaption('Mix and download final audio')", icon="fas fa-download", :isBusy="!!isMixing", @click="mixAndDownloadFinalAudio", :disabled="!dataIsLoadedFirst")
					template(slot="actions-left-end")
						AudioTrackerButtonGroup
							AudioTrackerButton.undo-item(icon="fas fa-undo-alt", @click="v => { undo() }", :disabled="!undoHistory().length || isUndoRedoExecuting")
								DxPopover(v-if="lastUndoOperation", target=".undo-item", position="bottom", show-event="mouseenter", hide-event="mouseleave")
									span {{lastUndoOperation}}
							AudioTrackerButton.redo-item(icon="fas fa-redo-alt", @click="v => { redo() }", :disabled="!redoHistory().length || isUndoRedoExecuting")
								DxPopover(v-if="nextRedoOperation", target=".redo-item", position="bottom", show-event="mouseenter", hide-event="mouseleave")
									span {{nextRedoOperation}}
							AudioTrackerButton(:title="$tCaption('Undo history', '@actions')", icon="fas fa-ellipsis-vertical", @click="showUndoHistory", :disabled="!(undoHistory().length + redoHistory().length)")
						AudioTrackerButton(:title="$tCaption('Speech streaming')", icon="fas fa-comment-dots", @click="$refs.speechStreaming.show()", :disabled="readonly")
						AudioTrackerButton(v-if="isDebug && debugInfo", :title="$tCaption('Debug info')", icon="fas fa-bug", @click="showDebugInfo")
					template(slot="actions-right")
						.flex-row.space.align-center
							AudioTrackerButton(v-if="dataIsLoadedFirst && creative.IsPublished === true", :title="$tCaption('Revise')", :text="$tCaption('Revise')", icon="fas fa-retweet", @click="showNewRevisionPopup")
							AudioTrackerButton(
								v-if="dataIsLoadedFirst && creative.IsPublished !== true && publicationAvailable",
								icon="fas fa-check",
								:text="$tCaption('Publish')",
								:title="$tCaption('Publish final audio')",
								:disabled="publishButtonDisabled",
								:isBusy="publicationInProgress",
								@click="v => $refs.creativePublish.publish()"
							)
							CreativePublishHistory(v-if="isCreativePublishHistoryVisible", :creative="creative", :hasPublishHistory="hasPublishHistory", :publicationStatistic="publicationStatistic",
								:downloadVariantsAsLinks="downloadVariantsAsLinks", :showPublicationSessionLogs="showPublicationSessionLogs", :cancelPublishFinalAudioServerside="cancelPublishFinalAudioServerside",
								ref="publishHistory")
					template(v-slot:post-effects-right="{ track, aggregatedTrack }")
						template(v-if="aggregatedTrack")
							AudioTrackerButton(:title="$auth.hasProAudio() ? $tCaption('Plugin and effects banks') : $tCaption('Effects banks')", icon="fas fa-database", @click="executeTrackAction('pluginsBank', track, void 0, aggregatedTrack)")
					template(v-slot:master-track-post-effects-left="{ postEffects }")
						AudioTrackerButton(:title="$auth.hasProAudio() ? $tCaption('Plugin and effects banks') : $tCaption('Effects banks')", icon="fas fa-database", @click="openPluginBanksFor(postEffects)")
				FileUploader(ref="insertionAudioUploader", :isUIHidden="true", :accept="['.mp3', '.wav', '.ogg', '.aac', '.flac', '.aiff', '.pcm']", @file-selected="fileUploading.selected = true", @upload="onNewInsertionFileUpload", 
					:dropText="$tCaption('Or drop audio files here to upload')",  :uploadText="editingTrack ? this.$tCaption('Save', '@actions') : null", :uploadButtonActive="editingTrack ? true : null"
				)
					.flex-col.space
						.flex-row.space-large.lr-padding(v-if="fileUploading.selected")
							.flex-row.space.align-center
								DxCheckBox(:value.sync="fileUploading.trim", :text="$tCaption('Trim')")
								DxNumberBox(v-show="fileUploading.trim",:value.sync="fileUploading.trimDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="0.1")
							.flex-row.space.align-center
								DxCheckBox(:value.sync="fileUploading.normalize",:text="$tCaption('Normalize')")
								DxNumberBox(v-show="fileUploading.normalize", :value.sync="fileUploading.normalizeDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="1")
						AudioInsertionDetail(v-if="editingTrack", ref="audioInsertionDetails" :track="editingTrack", :tracker="$refs.tracker")
				FileUploader(ref="insertionVideoUploader", :isUIHidden="true", :accept="['.mp4']", @file-selected="fileUploading.selected = true" @upload="onNewVideoFileUpload", :dropText="$tCaption('Or drop video files here to upload')", 
					:uploadText="editingTrack ? this.$tCaption('Save', '@actions') : null", :uploadButtonActive="editingTrack ? true : null"
				)
					AudioInsertionDetail(v-if="editingTrack", ref="audioInsertionDetails" :track="editingTrack", :tracker="$refs.tracker")
				FileUploader(ref="insertionMediaUploader", @file-selected="onMediaFileSelected", :isUIHidden="true", :accept="['.mp4', '.mp3', '.wav', '.ogg', '.aac', '.flac', '.aiff', '.pcm']",
					@upload="onNewMediaFileUpload", :dropText="$tCaption('Or drop media files here to upload')",  :uploadText="editingTrack ? this.$tCaption('Save', '@actions') : null",
					@remove-files="onMediaFileRemoved", :uploadButtonActive="editingTrack ? true : (fileUploading.downloadUrl || fileUploading.selected)"
				)
					.flex-col.space-medium.creative-detail
						.media-options-small(v-if="!fileUploading.selected")
							.flex-col.space
								.flex-row.space.align-center.font-small.upper.grey
									span {{$tCaption('Or provide link to download from')}}
									.flex-row.align-center.space-small
										fas(icon="fa-brands fa-youtube")
										span Youtube,
									.flex-row.align-center.space-small
										fas(icon="fa-brands fa-vimeo")
										span Vimeo,
									span {{$tCaption('or other source')}}:
								DxTextBox(:value.sync="fileUploading.downloadUrl", stylingMode="filled", placeholder="http://", valueChangeEvent="input")
						.media-options-small.flex-row.space-large.align-center(v-if="isMediaUploadingSourceSelected")
							.flex-row.space-medium.align-center(v-if="downloadUrlIsVimeoOrYoutube")
								DxCheckBox(:value.sync="fileUploading.grabAudio",:text="$tCaption('Import audio')")
								DxCheckBox(:value.sync="fileUploading.grabVideo",:text="$tCaption('Import video')")
							.flex-row.space-large(v-if="fileUploading.selected && !fileUploading.isVideo")
								.flex-row.space.align-center
									DxCheckBox(:value.sync="fileUploading.trim", :text="$tCaption('Trim')")
									DxNumberBox(v-show="fileUploading.trim",:value.sync="fileUploading.trimDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="0.1")
								.flex-row.space.align-center
									DxCheckBox(:value.sync="fileUploading.normalize",:text="$tCaption('Normalize')")
									DxNumberBox(v-show="fileUploading.normalize", :value.sync="fileUploading.normalizeDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="1")
							template(v-if="isMediaUploadingTranslateAvailable && !isSonicScribe")
								DxCheckBox(:value.sync="fileUploading.translate", :text="$tCaption('Transcribe')")
							template(v-if="isMediaUploadingSourceSelected")
								DxCheckBox(:value.sync="fileUploading.extractVoice", :text="isSonicScribe ? $tCaption('Remove music') : $tCaption('Extract voice')")
								DxCheckBox(v-if="!isSonicScribe", :value.sync="fileUploading.extractInstrumentals", :text="$tCaption('Extract instrumentals')")
							DxCheckBox(:value.sync="fileUploading.denoiser", :text="$tCaption('Denoiser')")
						.flex-row.space.align-center.media-options-small(v-if="fileUploading.translate && isMediaUploadingTranslateAvailable")
							.flex-col
								.font-small.upper.grey {{$tCaption('Source media language')}}
								DxSelectBox(:data-source="languages", :placeholder="$tCaption('Source media language')", :search-enabled="true", :showClearButton="true", :value="fileUploading.sourceLanguage && fileUploading.sourceLanguage.text",
									stylingMode="filled", display-expr="text", value-expr="text", @item-click="e => fileUploading.sourceLanguage = e.itemData", @selection-changed="e => { if (!e.selectedItem) { fileUploading.sourceLanguage = null; } }")
							.flex-col
								.spacer(v-html="'&nbsp'")
								DxCheckBox(:text="$tCaption('Translate')", :value="!fileUploading.transcribeOnly", @value-changed="e => fileUploading.transcribeOnly = !e.value")
							template(v-if="!fileUploading.transcribeOnly")
								.flex-col
									.spacer(v-html="'&nbsp'")
									fas(icon="arrow-right")
								.flex-col
									.font-small.upper.grey {{$tCaption('Target language')}}
									DxSelectBox(:data-source="languages", :placeholder="$tCaption('Target language')", :search-enabled="true", :showClearButton="true", :value="fileUploading.targetLanguage && fileUploading.targetLanguage.text",
										stylingMode="filled", display-expr="text", value-expr="text", @item-click="e => fileUploading.targetLanguage = e.itemData", @selection-changed="e => { if (!e.selectedItem) { fileUploading.targetLanguage = null; } }")
						template(v-if="isSonicScribe && isMediaUploadingSourceSelected")
							.flex-row.space-large
								.flex-col.flex-1
									.font-small.upper.grey {{$tCaption('Language')}}
									DxSelectBox(:data-source="languages", :placeholder="$tCaption('Language')", :search-enabled="true", :showClearButton="true", :value="sonicScribeLanguage",
										stylingMode="filled", display-expr="text", value-expr="locale", @item-click="e => sonicScribeLanguage = e.itemData.locale", @selection-changed="e => { if (!e.selectedItem) { sonicScribeLanguage = null; } }")
								.flex-col.flex-1(v-if="isDebug")
									.font-small.upper.grey {{$tCaption('STT Profile')}}
									Dropdown(
										:getTotal="(data) => data.TotalNumberOfRecords",
										:getItems="(data) => data.Results",
										:getData="getSTTProfiles",
										:columns="[{ dataField: 'Name', caption: $tCaption('Profile') }]",
										displayExpr="Name",
										valueExpr="Code",
										:selectedItems="sonicScrbieSTTProfile",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										:minSearchLength="0",
										@select-data="item => sonicScrbieSTTProfile = item ? item.Code : null"
									)
						AudioInsertionDetail(v-if="editingTrack", ref="audioInsertionDetails" :track="editingTrack", :tracker="$refs.tracker")
				AudioTrackerInsertion(
					ref="insertionEditor"
					:isUIHidden="true",
					:track="editingTrack",
					:tracker="$refs.tracker",
					:creativeIabCategories="creativeIabCategories",
					:templateFields="creative && creative.JsonConfig && creative.JsonConfig.templateFields",
					:isTemplate="creative && creative.IsTemplate",
					:readonly="$refs.tracker && $refs.tracker.focusedAggregatedTrack ? $refs.tracker.focusedAggregatedTrack.__readonly : readonly",
					:customContextMenuItems="insertionContextMenuItems",
					@delete-track="onDeleteTrack",
					@set-track="onInsertionSetTrack",
					@track-loading="onTrackLoading",
					@loading="v => isLoading += v"
					@popup="v => $refs.tracker && $refs.tracker.setTracksActive(!v)",
					@save="checkSimulateRulesAllTracks",
					@remove="onDeleteTrack",
					@reload-tracks="reloadTracks",
					@update-tags="updateTags",
					@create-template-field="onCreateTemplateField"
				)
					template(v-slot:right-settings="data")
						CreativeInsertionNewsMLSettings(v-if="creative && creative.IsNewsMLTemplate", :record="data.record")
				SonicScribe.lr-padding(v-if="creative && isSonicScribe", :creative="creative", :tracker="$refs.tracker", :busy="!dataIsLoadedFirst", @add-file="createInsertion('media')", :loading="isLoading",
					@save="onAudioInsertionTextBasedAudioEditor", :readonly="readonly", :sonicScribeInfo="sonicScribeInfo", :executeTrackAction="executeTrackAction", :hasAppliedCustomSettings="hasAppliedCustomSettings",
					:getActiveWapiPlugin="getActiveWapiPlugin")
					template(slot="actions-left")
						.flex-row.space.align-center
							AudioTrackerButton(v-if="dataIsLoadedFirst && creative.IsPublished === true", :title="$tCaption('Revise')", :text="$tCaption('Revise')", icon="fas fa-retweet", @click="showNewRevisionPopup")
							AudioTrackerButton(
								v-if="dataIsLoadedFirst && creative.IsPublished !== true && publicationAvailable",
								icon="fas fa-check",
								:text="$tCaption('Publish')",
								:title="$tCaption('Publish final audio')",
								:disabled="publishButtonDisabled",
								:isBusy="publicationInProgress",
								@click="v => $refs.creativePublish.publish()"
							)
							CreativePublishHistory(v-if="isCreativePublishHistoryVisible", :creative="creative", :hasPublishHistory="hasPublishHistory", :publicationStatistic="publicationStatistic")
			.creative-header-data(v-else)
				.lr-padding
					SimpleAudioLoader(v-if="creative && loadedInsertions", :creative="creative", :insertions="loadedInsertions", @save-creative="() => $updateCreative('save-creative')")
		template(v-if="!isPublishMode")
			CreativeVastLink(ref="vastLink")
			SSMLSplitter(v-if="textToSpeech.splitVisible && editingTrack", :visible="textToSpeech.splitVisible", :ssml="editingTrack.insertion.Ssml",
				@split="v => { splitSsml(editingTrack, v); editingTrack = null; }", @hiding="textToSpeech.splitVisible = false")
			AudioTrackInfoPanelPluginsBank(ref="pluginsBank", :aggregatedTrack="focusedAggregatedTrack", :masterTrackConfig="creative && creative.JsonConfig && creative.JsonConfig.masterTrackConfig", 
				:pluginsBankVisible.sync="pluginsBankVisible", @select="v => selectedPluginsBank = v", @apply="applyPluginsBank(focusedAggregatedTrack)")
				template(slot="actions-right")
					DxButton(:text="$tCaption('Apply', '@actions')", type="default", @click="() => applyPluginsBank(focusedAggregatedTrack)", :disabled="!selectedPluginsBank")
					DxButton(:text="$tCaption('Cancel', '@actions')", @click="pluginsBankVisible = false")
			SubInsertionsGenerator(ref="subInsertionsGenerator", :tracker="$refs.tracker", :editingInsertionCmp="$refs.insertionEditor", :creative="creative",
				@started="onSubInsertionsGenerationStarted", @generated="onSubInsertionsGenerated")
			SubInsertionsRecorder(ref="subInsertionsRecorder", :tracker="$refs.tracker", :track="editingTrack", :subTrackResolver="onNewAudioRecordedSubTrack")
			CreativePublish(ref="creativePublish", :creative="creative", :publicationStatistic.sync="publicationStatistic", @publish="onPublishFinalAudioServerside", @publish-initialized="onPublishFinalAudioServersideInitialized")
		DetailIabCategories(ref="creativeIabCategories", v-bind="{ ...selfBindableOptions }")
		Popup(v-if="!!publicationLog", :popupVisible="!!publicationLog" :width="920", :height="640", :title="$tCaption('Logs')", :closeOnOutsideClick="false" @hiding="publicationLog = null")
			.flex-col.space-medium
				.flex-col
					.font-small.upper.grey {{$tCaption('Server logs')}}
					pre {{publicationLog.ServerLogs}}
				.flex-col
					.font-small.upper.grey {{$tCaption('Client logs')}}
					a(:href="publicationLog.ClientLogsUrl", target="_blank") {{publicationLog.ClientLogsUrl}}
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="publicationLog = false")
		Popup(v-if="breakPopupVisible", :popupVisible.sync="breakPopupVisible", :defaultActions="true", :width="520", :height="340", :title="$tCaption('Break')", :closeOnOutsideClick="false", @success="saveBreakInsertion",
			:validate="() => editingTrack.duration > 0")
			CreativeBreakInsertion(:editingTrack="editingTrack", :breakTypes="breakTypes")
		CreativeTranslationsQA(v-if="translatedTracks.length", ref="translationsQA", :creative="creative", :tracks="translatedTracks", :creativeDetail="_self")
		AggregatedTrackCriteriaEditor(ref="aggregatedTrackCriteriaEditor", :templateFields="creative && creative.JsonConfig && creative.JsonConfig.templateFields", :allowKeyEditing="creative && creative.IsTemplate", :tracker="$refs.tracker")
		CreativeSettings(v-if="creative", ref="creativeSettings", :creative="creative")
		AudioOverdubbingTool(ref="audioOverdubbingTool", @save="onAudioInsertionOverdubbing")
		AudioConversionTool(ref="audioConversionTool", @save="onAudioInsertionConversion")
		CreativeTextBasedAudioEditorPopup(ref="textBasedAudioEditor", @save="onAudioInsertionTextBasedAudioEditor")
		CreativeSpeechStreaming(v-if="creative", ref="speechStreaming", :aggregatedTracks="creative.JsonConfig.aggregatedTracks")
		CreativeUndoHistory(v-if="creative", ref="undoHistory", :operations="undoRedoOperations", :isUndoRedoExecuting="isUndoRedoExecuting")
		CreativeFileUploadRequest(v-if="(creative || isFileUploadRequest) && !isSonicScribe", ref="fileUploadRequest", :creative="creative", :uploadMode="isFileUploadRequest", :creativeIsBusy="creativeIsBusy", 
			:tracker="$refs.tracker", :createInsertion="createInsertion", @edit="v => editingTrack = v")
		CreativeDebugInfo(ref="debugInfo", :creative="creative")
		CreativeVoiceMessage(v-if="hasVoiceMessages", ref="voiceMessage", :creative="creative", :opts="opts")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxColorBox from 'devextreme-vue/color-box';
	import AudioTracker from 'view/audioTracker/AudioTracker.vue';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import DxContextMenu from 'devextreme-vue/context-menu';
	import { DxPopover } from 'devextreme-vue/popover';
	import AudioTrackerInsertion from '../audioTracker/AudioTrackerInsertion.vue';
	import FileUploader from 'app-core/FileUploader.vue';
	import SimpleAudioLoader from './SimpleAudioLoader.vue';
	import CreativeVastLink from './CreativeVastLink.vue';
	import AudioTrackerButton from 'view/audioTracker/AudioTrackerButton.vue';
	import AudioTrackerButtonGroup from 'view/audioTracker/AudioTrackerButtonGroup.vue';
	import SSMLSplitter from 'view/insertion/SSMLSplitter.vue';
	import ListView from 'app-core/ListView.vue';
	import AudioTrackInfoPanelPluginsBank from 'view/audioTracker/AudioTrackInfoPanelPluginsBank.vue';
	import Popup from 'app-core/Popup.vue';
	import PopupBody from 'app-core/PopupBody.vue';	
	import SubInsertionsGenerator from './SubInsertionsGenerator.vue';
	import SubInsertionsRecorder from './SubInsertionsRecorder.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import Loader from 'app-core/Loader.vue';
	import CreativePublish from './CreativePublish.vue';
	import CreativeDetail from './CreativeDetail.vue';
	import CreativeNewApproval from './CreativeNewApproval.vue';
	import AudioInsertionDetail from 'view/insertion/AudioInsertionDetail.vue';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import CreativeFile from './CreativeFile.vue';
	import DetailIabCategories from './DetailIabCategories.vue';
	import DetailHeader from './DetailHeader.vue';
	import CreativeBreakInsertion from './CreativeBreakInsertion.vue';
	import DxSelectBox from 'devextreme-vue/select-box';
	import CreativeTranslationsQA from './CreativeTranslationsQA.vue';
	import AggregatedTrackCriteriaEditor from './AggregatedTrackCriteriaEditor.vue';
	import CreativeSimulateRules from './CreativeSimulateRules.vue';
	import AudioOverdubbingTool from './AudioOverdubbingTool.vue';
	import AudioConversionTool from './AudioConversionTool.vue';
	import CreativeTextBasedAudioEditorPopup from './CreativeTextBasedAudioEditorPopup.vue';
	import CreativeSettings from './CreativeSettings.vue';
	import CreativeInsertionNewsMLSettings from './CreativeInsertionNewsMLSettings.vue';
	import detailCoreMixin from './detail-core';
	import CreativeSpeechStreaming from './CreativeSpeechStreaming.vue';
	import CreativeUndoHistory from './CreativeUndoHistory.vue';
	import SonicScribe from './SonicScribe.vue';
	import CreativePublishHistory from './CreativePublishHistory.vue';
	import CreativeFileUploadRequest from './CreativeFileUploadRequest.vue';
	import CreativeDebugInfo from './CreativeDebugInfo.vue';
	import CreativeVoiceMessage from './CreativeVoiceMessage.vue';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative-detail',
		components: {
			DxButton, DxTextBox, DxTextArea, DxNumberBox, DxDropDownButton, DxContextMenu, DxCheckBox, DxColorBox, DxSelectBox, DxValidationGroup, DxPopover,
			FileUploader, ListView, Popup, PopupBody, Dropdown, Loader, CreativeSettings, CreativeInsertionNewsMLSettings, AudioTrackerButtonGroup,
			AudioTracker, AudioTrackerInsertion, AudioTrackerButton, SimpleAudioLoader, CreativeVastLink, SSMLSplitter, AudioTrackInfoPanelPluginsBank, AudioInsertionDetail,
			SubInsertionsGenerator, SubInsertionsRecorder, CreativePublish, CreativeDetail, CreativeNewApproval, CreativeFile, DetailIabCategories, DetailHeader,
			CreativeBreakInsertion, CreativeTranslationsQA, AggregatedTrackCriteriaEditor, CreativeSimulateRules, AudioOverdubbingTool, AudioConversionTool,
			CreativeTextBasedAudioEditorPopup, CreativeSpeechStreaming, CreativeUndoHistory, SonicScribe, CreativePublishHistory, CreativeFileUploadRequest,
			CreativeDebugInfo, CreativeVoiceMessage
		},
		props: ['creativeId', 'isNew', 'disabled', 'opts', 'forceTracker'],
		mixins: [
			detailCoreMixin
		]
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.creative-detail--publish-error {
		font-size: 11px;
		line-height: 12px;
		font-weight: 100;
		color: #f00;
	}

	.creative-detail--in-queue {
		color: $base-accent;
	}

	.creative-detail--simulation-rule-icon {
		opacity: 0.2;

		&.active {
			opacity: 1;
		}
	}

	.creative-detail {
		.creative-editing-lock {
			font-size: 12px;
			padding: 2px 4px;
			background: #ff7171;
			color: #fff;
			border-radius: 4px;
		}

		.track-name {
			cursor: pointer;
			position: relative;

			.color-picker-popup {
				position: absolute;
				right: 0px;
				top: 0px;
			}

			.text {
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 120px;
				color: var(--color);
			}

			input {
				font-size: 12px;
				color: var(--color);
				padding: 4px !important;
			}

			.color-picker {
				width: 20px;
				height: 20px;
				background: rgba(0, 0, 0, 0.075);
				border-radius: 30px;

				.color-picker-icon {
					color: var(--color);

					&:hover {
						opacity: 0.7;
					}
				}
			}

			.track-duration {
				background: #dfdfdf;
				position: absolute;
				right: 0px;
				bottom: 0px;
				padding: 0px 2px;
			}
		}

		.creative-header-data {
			margin: 10px;
		}

		.left-items {
			min-width: 340px;
		}

		.edit-creatives {
			margin-left: 20px;
		}

		.audio-track-info.track.subtrack .track-info-holder {
			background: #e9aa94;
			padding-left: 6px;
			width: 20px;
		}

		.audio-track-info.track.subtrack .track-info {
			background: #e0e0e0;
		}

		.action {
			cursor: pointer;
		}

		.variant {
			.variant-button {
				color: $base-accent;
				font-size: 10px;
				line-height: 1;
			}
		}

		.canvas-actions-button {
			height: 18px;

			.dx-item.dx-buttongroup-item {
				height: 20px;
				width: 20px;

				.dx-icon {
					width: 10px;
					height: 10px;
					line-height: 10px;
					margin-left: -14px;
				}
			}
		}

		.loader-holder {
			max-height: 20px;
		}

		.link-to-insertion {
			padding: 4px;
			border-radius: 4px;

			&.dest {
				background: $base-accent;
			}

			&.source {
				background: #fff;
			}
		}

		.has-linked-to {
			font-size: 10px;
			padding: 4px;
			color: $base-accent;
		}

		.media-options {
			margin-top: 30px;
		}

		.media-options-small {
			margin-top: 8px;
		}

		.links-holder {
			position: absolute;
			left: 0px;
			right: 0px;
			top: 0px;
			bottom: 0px;
			width: 100%;
			height: 100%;
			z-index: 10000;
			cursor: pointer;

			.overlay {
				height: 100%;
				width: 100%;
				opacity: 0.75;
				background: #ececec;
				position: absolute;
				pointer-events: none;
			}

			> .link {
				position: absolute;
				width: 18px;
				background: #e1e1e199;
				border: 0px solid #dadada;
				font-size: 10px;
				color: #777;
				top: 0px;
				bottom: 0px;

				&.left {
					left: 0px;
					border-radius: 4px 0px 0px 4px;
					border-left: 3px solid #ccc;

					&:hover {
						border-left-color: $base-accent;
					}
				}

				&.right {
					right: 0px;
					border-radius: 0px 4px 4px 0px;
					border-right: 3px solid #ccc;

					&:hover {
						border-right-color: $base-accent;
					}
				}

				&:hover {
					color: $base-accent;
					background: #d1d1d1;
				}
			}
		}
	}

	.iab-categories-str {
		display: inline-block;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 400px;
		overflow: hidden;
	}

	.iab-categories-selection {
		.iab-item {
			background: $base-accent;
			color: $base-bg;
			border-radius: 4px;
			margin-right: 10px;
			margin-bottom: 10px;
		}

		.iab-categories-selected {
			height: calc(100vh - 400px);
			max-height: 490px;
			margin-top: 16px;
		}

		.loader {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 1);
			z-index: 1001;

			.loader-icon {
				font-size: 40px;
				color: #f27649;
			}
		}

		.dx-toolbar .dx-toolbar-items-container {
			height: 46px !important;
		}

		.iab-spacer {
			height: 6px;
		}
	}
</style>
